/*
* isPinned
* groups
* brandText
*/

import config from '@/assets/top-bar-config';

export const topbar = {
  namespaced : true,
  state : {
    hotlinks    : config.hotlinks
  },
  actions : {

  },
  mutations : {

  }
}
